const ProjectDiagnosticConfig = {
  id: "projectDiagnostic",
  title: "What Kind of Project Help Do I Need?",
  description:
    "Answer a few questions to understand the urgency, scope, and next step for your home project.",
  ctaLabel: "See My Results",
  defaults: {},
  severityLabels: {
    low: "Mostly planning or low urgency",
    medium: "Worth reviewing or planning soon",
    high: "Time-sensitive, complex, or potentially urgent",
  },
  result: {
    title: "What This Means",
    disclaimer:
      "This assessment is informational only and does not replace a professional inspection.",
  },
};

export default ProjectDiagnosticConfig;
